// FT-217 REQ-02 / OQ-02: подпись ценовой группы — «2 900–3 300 ₽», «3 300 ₽»,
// «290–330 ₽/ч», «Без цены». Подпись не хранится: сервер отдаёт границы min/max
// текущих цен группы и единицу филиала (day | hour), строку собирает клиент.
// Один хелпер на все четыре места (доска, виджет, карточка машины, настройки),
// чтобы подпись одной и той же группы нигде не расходилась.
//
// Числа — formatMoney модуля выкупа: единственный общий форматтер денег
// приложения (Intl.NumberFormat по языку интерфейса, копейки — только если есть).
// Доска и список машин печатают цены голым числом без разделителя тысяч, а
// подпись диапазона без разделителя («2900–3300») читается хуже — поэтому не он.
// Символ валюты — getCompany.company.currency, как во всём интерфейсе.
import { formatMoney } from "@/components/dashboard/rent_to_own/rentToOwnFormat";

// Ключ сводки «машины без группы» в ответах API (CTR-01, CTR-04).
export const NO_GROUP_KEY = "none";

// Группы [{ min, ... }] по минимальной цене ↑ (порядок REQ-02) — копией, исходный
// массив не трогаем.
export function sortByMinPrice(groups) {
  return (groups || []).slice().sort((a, b) => (a.min || 0) - (b.min || 0));
}

// group — { min, max } (или null / { min: null }) для «Без цены»;
// unit — "day" | "hour" | null; currency — символ валюты; locale — язык
// интерфейса; t — функция перевода ($t).
export function priceGroupLabel(group, { unit, currency = "", locale, t } = {}) {
  const min = group ? group.min : null;
  const max = group && group.max != null ? group.max : min;
  if (min == null) return t ? t("price_groups.no_price") : "";
  const from = formatMoney(min, { locale });
  const to = formatMoney(max, { locale });
  const range = from === to ? from : `${from}–${to}`;
  const suffix = unit === "hour" && t ? t("price_groups.per_hour_suffix") : "";
  return currency ? `${range} ${currency}${suffix}` : `${range}${suffix}`;
}

// Те же параметры из компонента: валюта из стора, язык из i18n. Оба источника
// необязательны — в юнит-тестах $store и $i18n могут отсутствовать.
export function priceGroupLabelOptions(vm, unit) {
  const getters = vm.$store && vm.$store.getters;
  const company = getters && getters.getCompany && getters.getCompany.company;
  return {
    unit,
    currency: (company && company.currency) || "",
    locale: (vm.$i18n && vm.$i18n.locale) || undefined,
    t: vm.$t.bind(vm),
  };
}
